import { LandingsRepository } from "../../repository/api/landing/landing";
import { actionCreators } from "../../state";

export class LandingUseCases {
    private api: LandingsRepository;
    private stateActions: typeof actionCreators;

    constructor(api: LandingsRepository, stateActions: typeof actionCreators) {
        this.api = api;
        this.stateActions = stateActions;
    }

    public ReadLandings = async () => {
        this.stateActions.SendLandingListRequest()
        let response = await this.api.ReadLandings()
        if (response instanceof Error) {
            this.stateActions.LandingListError(response.message)
            return
        } else {
            this.stateActions.LandingListSuccess(response)
        }
    }

    public DeleteLanding = async (id: UniqueId) => {
        this.stateActions.LandingDeleteRequest()
        let response = await this.api.DeleteLandingById(id)
        if (response instanceof Error) {
            this.stateActions.LandingDeleteError(response.message)
            return
        } else {
            this.stateActions.LandingDeleteSuccess(id)
        }
    }

    public ReadLandingById = async (id: UniqueId) => {
        let response = await this.api.ReadLandingById(id)
        return response
    }

    public CreateLanding = async (domain: string,imagesPath: string,isWithThumb: boolean,thumbWidth: number,thumbHeight: number,thumbPostfix: string,bigImageWidth: number, callback?: ()=>void) => {
        this.stateActions.LandingCreateRequest()
        let response = await this.api.CreateLanding(domain,imagesPath,isWithThumb,thumbWidth,thumbHeight,thumbPostfix,bigImageWidth,)
        if (response instanceof Error) {
            this.stateActions.LandingCreateError(response.message)
            return
        } else {
            this.stateActions.LandingCreateSuccess(response)
            if (callback) {
                callback()
            }
        }
    }

    public UpdateLanding = async (id: UniqueId, domain: string,imagesPath: string,isWithThumb: boolean,thumbWidth: number,thumbHeight: number,thumbPostfix: string,bigImageWidth: number, callback?: ()=>void) => {
        this.stateActions.LandingUpdateRequest()
        let response = await this.api.UpdateLanding(id, domain,imagesPath,isWithThumb,thumbWidth,thumbHeight,thumbPostfix,bigImageWidth,)
        if (response instanceof Error) {
            this.stateActions.LandingUpdateError(response.message)
            return
        } else {
            this.stateActions.LandingUpdateSuccess(response)
            if (callback) {
                callback()
            }
        }
    }

}